import {Directive} from '@angular/core';

@Directive({
	selector: '[kFormLabel]'
})
export class FormLabelDirective {
}
